import { ColorStyles, FontStyles } from "../../../DomMapper/Static/GroupsStyles.static";
import { IPartialCSS } from "partnerbuilder-common";

export const NavbarLinkStyles: IPartialCSS<any> = {
    ...ColorStyles,
    ...FontStyles
};
